import { callEnded, joinVideo } from "actions/videoAction";
import { PAGE_HEIGHT_WITH_NAVBAR } from "common/helpers";
import { color, space } from "common/tokens";
import VideoFrameContainer from "containers/VideoFrameContainer";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

// A Zoom call fills a laptop screen but stops growing on large monitors.
const ZOOM_CALL_MAX_WIDTH = 1600;

const JoinVideoCall = ({ match, id: userId, setCurrentPath }) => {
  const roomId = match.params.roomId;
  const dispatch = useDispatch();
  const isZoomCall = useSelector(({ video }) => video.room?.provider === "zoom");

  useEffect(() => {
    setCurrentPath('chat');
  }, [setCurrentPath]);

  useEffect(() => {
    if (roomId) {
        dispatch(joinVideo(roomId))
    }
  }, [dispatch, roomId, userId])

  // Leaving the call page ends the call for this tab. Without this the flag
  // stays set for the rest of the session and every nav click is treated as
  // navigating away from a live call, which opens a new tab.
  useEffect(() => () => { dispatch(callEnded()) }, [dispatch])

  return (
    <div style={{background: color.SURFACE, height: PAGE_HEIGHT_WITH_NAVBAR, overflow: 'auto'}}>
      {/* The call sits in the same column as the rest of the redesign; going
          full screen is `position: fixed`, so it still escapes this. */}
      <div
        style={{
          width: '100%',
          maxWidth: isZoomCall ? ZOOM_CALL_MAX_WIDTH : space.CONTAINER_MAX,
          margin: '0 auto',
          padding: isZoomCall ? '16px 24px' : '24px 32px',
          boxSizing: 'border-box',
          ...(isZoomCall && { height: '100%', display: 'flex', flexDirection: 'column' }),
        }}
      >
        <VideoFrameContainer isActive={true}/>
      </div>
    </div>
  );
};

export default withRouter(JoinVideoCall);
